import React from 'react';

import { Container } from './styles';

const ModalHeader: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default ModalHeader;
